module.exports = __webpack_public_path__ + "static/media/camera@1x.37bc8980.svg";